import React from "react";
import "./Jumbotron.css"

const Jumbotron = () => {
return (
    <>
    <div className="container">
    </div>
    </>
)
}

export default Jumbotron